import { Col, Input } from "antd";
import React from "react";

const SearchBar = (props) => {
  const searching = (searchText) => {
    props.getSearchText(searchText);
  };
  const isText = (e) => {
    if (!e.target.value) {
      props.hideSearchResults();
    }
  };
  return (
    <Col>
      <Input.Search
        onChange={isText}
        onSearch={searching}
        data-testid='submit-search'
        placeholder={props.searchHolder}
      ></Input.Search>
    </Col>
  );
};

export default SearchBar;
